<template>
  <div class="AddCourseResource">
    <a-spin class="AddCourseResource-left" :spinning="tree.treeLoading">
      <a-tabs @change="tabsChange" v-model="tabActive" v-if="showTabs">
        <a-tab-pane v-for="item in tabs" :key="item.type" :tab="item.name"/>
      </a-tabs>
      <a-tree @select="treeSelect" :tree-data="tree.treeData"
              style="padding-right: 5px;"
              :key="tree.key"
              :selectedKeys.sync="tree.selectValue"
              :replaceFields="{ key: 'id', }"
              show-icon default-expand-all block-node>
        <div slot="treeItem" slot-scope="title" class="tree-item">
          <img v-if="!(title.children && title.children.length)" class="tree-icon"
               src="@/assets/img/course/course-file.png" alt="">
          <img v-else class="tree-icon" src="@/assets/img/course/course-folder.png" alt="">
          <span :title="title.name">{{ title.name }}</span>
        </div>
      </a-tree>
    </a-spin>
    <div class="AddCourseResource-right">
      <a-form-model layout="inline" :model="searchForm" style="margin-bottom: 15px;">
        <a-form-model-item label="课程系列">
          <a-input :maxLength="30" v-model="searchForm.name" placeholder="请输入系列名称"/>
        </a-form-model-item>
        <a-form-model-item label="课程名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.courseName"
                   placeholder="请输入课程名称"/>
        </a-form-model-item>
        <a-form-model-item label="系列说明">
          <a-input :maxLength="30" v-model="searchForm.remark" placeholder="请输入关键词"/>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="getPageList(1)" type="primary" html-type="button">
            查询
          </a-button>
          <a-button @click="searchReset" style="margin-left: 10px;">
            重置
          </a-button>
        </a-form-model-item>
      </a-form-model>
      <a-table :columns="columns"
               row-key="id"
               @expand="tableExpand"
               :pagination="tableRelevant.tablePagination"
               :loading="tableRelevant.tableLoading"
               :locale="tableRelevant.locale"
               :scroll="{y: 350}"
               :dataSource="tableRelevant.tableDataSource">
        <a-table slot="expandedRowRender"
                 class="inner-table"
                 slot-scope="text"
                 :key="text.key"
                 row-key="id"
                 :columns="innerColumns"
                 :row-selection="innerRowSelection"
                 :data-source="text.tableData"
                 :loading="text.tableLoading"
                 :pagination="false">
          <div class="course-name" slot="name" :title="text.name" slot-scope="text">
            <img :src="text.icon | filterUrl" alt="">
            <span>{{ text.name }}</span>
          </div>
          <div slot="courseType" slot-scope="text">
            {{ text === 1 ? "测评课程" : text === 2 ? "训练课程" : '活动课程' }}
          </div>
          <div slot="price" slot-scope="text" style="color: red;">
            ￥{{ text }}
          </div>
        </a-table>
      </a-table>
    </div>
  </div>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";

const columns = [
  {title: '课程系列', dataIndex: 'name', width: 250, ellipsis: true},
  {title: '系列说明', dataIndex: 'remark', ellipsis: true},
];
const innerColumns = [
  {
    title: '课程名称',
    scopedSlots: {customRender: 'name'},
  },
  {
    title: '适用学段',
    dataIndex: 'period',
    width: 100,
  },
  {
    title: '类型',
    dataIndex: 'courseType',
    width: 90,
    scopedSlots: {customRender: 'courseType'},
  },
  {
    title: '课时数',
    width: 80,
    dataIndex: 'courseSessionCount',
  },
  {
    title: '报告数',
    width: 80,
    dataIndex: 'reportCount',
  },
  {
    title: '价格',
    dataIndex: 'price',
    width: 90,
    scopedSlots: {customRender: 'price'},
  },
];

export default {
  name: "AddCourseResource",
  props: {
    type: String,
    courseType: [String, Number],
  },
  data() {
    return {
      organizationId: sessionStorage.getItem("ORGANIZATION_ID"),
      tabs: [{type: 1, name: "B端"}, {type: 2, name: "C端"}, {type: 3, name: "实验"}],
      tabActive: 1,
      tree: {
        key: Date.now(),
        selectValue: undefined,
        treeLoading: false,
        treeData: [],
      },
      columns,
      innerColumns,
      searchForm: {
        name: undefined,
        courseName: undefined,
        remark: undefined,
        classificationId: undefined,
      },
      tableRelevant: tableRelevant.call(this),
      table: tableRelevant.call(this),
      seriesSelectedRowKeys: [],
      courseSelectedRowKeys: [],
      showTabs: true,
    };
  },
  computed: {
    innerRowSelection() {
      return {
        selectedRowKeys: this.courseSelectedRowKeys,
        type: 'radio',
        getCheckboxProps: record => ({
          props: {
            disabled: record.isSelect,
          },
        }),
        // onSelect: (record, selected) => {
        //     const tableData = this.tableRelevant.tableDataSource.filter(f => f.id === record.courseSeriesId)[0].tableData;
        //     let length = tableData.length;
        //     while (length--) {
        //         if (this.courseSelectedRowKeys.indexOf(JSON.stringify(tableData[length])) === -1) {
        //             const index = this.seriesSelectedRowKeys.indexOf(record.courseSeriesId);
        //             if (index >= 0) this.seriesSelectedRowKeys.splice(index, 1);
        //             return
        //         }
        //     }
        //     this.seriesSelectedRowKeys.push(record.courseSeriesId);
        // },
        onChange: (selectedRowKeys, selectedRows) => {
          this.courseSelectedRowKeys = selectedRowKeys;
          console.log(this.courseSelectedRowKeys);
        },
      };
    },
  },
  mounted() {
    console.log(this.$route.name);
    this.tabsChange();
  },
  methods: {
    selectTableRow(selected, selectedRows) {
      if (selected) {
        for (let i = 0; i < selectedRows.length; i++) {
          selectedRows[i].tableData.forEach(f => {
            if (this.courseSelectedRowKeys.indexOf(JSON.stringify(f)) === -1 && !f.isSelect) {
              this.courseSelectedRowKeys.push(JSON.stringify(f));
            }
          });
        }
      } else {
        for (let i = 0; i < selectedRows.length; i++) {
          selectedRows[i].tableData.forEach(f => {
            let index = this.courseSelectedRowKeys.indexOf(JSON.stringify(f));
            if (index >= 0) {
              this.courseSelectedRowKeys.splice(index, 1);
            }
          });
        }
      }
    },
    tabsChange() {
      function initData(arr, index) {
        return arr.map(m => {
          if (m.id === null) {
            m.id = 0;
          }
          if (m.children && m.children.length) {
            m.children = initData(m.children, index + 1);
          }
          m.index = index;
          m.scopedSlots = {title: 'treeItem'};
          return m;
        });
      }

      this.tree.treeLoading = true;
      this.$http.CourseResource.classificationsGet({resourceType: 0, type: this.tabActive}).then(({data}) => {
        this.tree.treeData = initData([data], 0);
        this.tree.key = Date.now();
        console.log(this.tree.treeData);
      }).finally(() => {
        this.tree.treeLoading = false;
      });
      this.tree.selectValue = undefined;
      this.searchReset();
    },
    treeSelect(selectedKeys) {
      this.searchForm.classificationId = selectedKeys[0] || undefined;
      this.getPageList(1);
    },
    getPageList(page) {
      console.log(this.type);
      let params = {
        type: this.tabActive,
        courseType: undefined,
        enabled: true,
        pageIndex: page || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      };

      this.tableRelevant.tableLoading = true;
      this.$http.CourseResource.seriesGet(params)
        .then(({data}) => {
          this.tableRelevant.tableDataSource = data.items;
          this.tableRelevant.tablePagination.total = data.totalCount;
          this.tableRelevant.tablePagination.current = data.pageIndex;
        }).finally(() => {
        this.tableRelevant.tableLoading = false;
      });
    },
    searchReset() {
      this.searchForm = {
        name: undefined,
        remark: undefined,
      };
      this.getPageList(1);
    },
    tableExpand(expanded, record){
      expanded && this.getCourseList(record.id);
    },
    getCourseList(id) {
      let params = {
        CourseSeriesId: id,
        CourseType: this.courseType
      };
      this.tableRelevant.tableLoading = true;
      this.$http.CourseResource.courseAll(params).then(res => {
        this.tableRelevant.tableDataSource = this.tableRelevant.tableDataSource.map(m => {
          m.tableLoading = false
          if (m.id === id) {
            m.tableData = res.data;
          }
          return m;
        });
      }).finally(() => {
        this.tableRelevant.tableLoading = false;
      })
    },
  },
};
</script>

<style scoped>
.AddCourseResource {
  display: flex;
}

.AddCourseResource-left {
  width: 300px;
  min-height: 360px;
  flex-shrink: 0;
  border-right: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
  margin-bottom: 63px;
}

.AddCourseResource-right {
  flex-grow: 1;
  padding-left: 24px;
}

.tree-item {
  display: flex;
  align-items: center;
}

.tree-item > span {
  flex-shrink: 2;
  flex-grow: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.tree-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  margin-right: 5px;
}

.course-name {
  display: flex;
  align-items: center;
}

.course-name span {
  flex-grow: 2;
}

.course-name img {
  width: 25px;
  height: 25px;
  object-fit: contain;
  margin-right: 5px;
  flex-shrink: 0;
}

.inner-table >>> .ant-table-selection-column .ant-table-header-column {
  display: none;
}

/deep/ .ant-tabs-nav-wrap {
  display: flex;
  justify-content: center;
}
</style>
